
import { ReactElement } from "react";
import { AddonParams, BaseAddon } from "../base/BaseAddon";
import { StepChangeEvent, StepType } from "../../types/types";
import { SelectSheetStep } from "../../components/SelectSheetStep/SelectSheetStep";
import toastService from "../../../../../core/toaster/ToasterService";
import { exceedsMaxRecords } from "../../utils/exceedsMaxRecords";
import { TOASTER_TOAST_TIME } from "../../../../../core/toaster/Toaster_model";
import I18n from "../../../../../core/localization/I18n";
import { mapWorkbook } from "../../utils/mapWorkbook";


export class SelectSheetAddon<T extends string = string> extends BaseAddon<T> {
  constructor(
    onNext: (event: StepChangeEvent) => void,
    onBack: () => void,
    params: AddonParams<T>

  ) {
    super('SelectSheetAddon', [StepType.selectSheet], onNext, params);
    this.onBack = onBack;
  }

  private onBack: () => void;

  protected getJSXElement(step: StepType, data: any): ReactElement {
    if (!data.workbook) {
      return <div>No workbook found</div>;
    }

    return (
      <SelectSheetStep
        sheetNames={data.workbook.SheetNames}
        onContinue={async (sheetName: string) => {
          await this.handleSheetSelection(data.workbook, sheetName);
        }}
        onBack={this.onBack}
      />
    );
  }

  private async handleSheetSelection(workbook: any, sheetName: string): Promise<void> {
    if (this.maxRecords && exceedsMaxRecords(workbook.Sheets[sheetName], this.maxRecords)) {
      toastService
        .showErrorToast(TOASTER_TOAST_TIME.NORMAL, "right")
        .setContent(
          <span>
            {I18n.t("phrases.uploadStepMaxRecordsExceeded", { name: this.maxRecords?.toString() ?? "" })}
          </span>
        );
      return;
    }
    
    try {
      const mappedWorkbook = await this.uploadStepHook(mapWorkbook(workbook, sheetName));
      
      this.onNext({
        type: StepType.selectHeader,
        data: mappedWorkbook
      });
    } catch (e) {
      toastService.showErrorToast(TOASTER_TOAST_TIME.NORMAL, "right").setContent(<span>{e?.message}</span>);
    }
  }
}